
















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import Ajax from "@/lib/ajax";
import moment from "moment";

class CouponPeriod {
  validStartDate: string = "";
  validEndDate: string = "";
}

class Coupon {
  courtId: number = 0;
  userIds: any[] = [];
  quantity: number = 1;
  validStartDate: string = "";
  validPeriods: CouponPeriod[] = [];
}

@Component({
  components: {},
})
export default class SeletedCourt extends AbpBase {
  @Prop({ type: Boolean, default: false })
  value: boolean;

  @Prop({ type: Array })
  userIds: Array<any>;

  coupon: Coupon = new Coupon();
  courtList = [];
  isShow = true;

  save() {
    (this.$refs.couPonRef as any).validate(async (valid: boolean) => {
      if (valid) {
        (this.$refs.couPonRef as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }

  addPeriod() {
    this.coupon.validPeriods.push(new CouponPeriod());
  }

  removePeriod(index: number) {
    this.coupon.validPeriods.splice(index, 1);
  }

  submit() {
    (this.$refs.couPonRef as any).validate((valid: boolean) => {
      if (valid && this.userIds && this.userIds.length > 0) {
        const payload = {
          ...this.coupon,
           validStartDate: this.coupon.validStartDate
            ? moment(this.coupon.validStartDate).format("YYYY-MM-DD HH:mm:ss")
            : undefined,
          userIds: this.userIds,
           validPeriods: (this.coupon.validPeriods || []).map((p) => ({
            validStartDate: p.validStartDate
              ? moment(p.validStartDate).format("YYYY-MM-DD HH:mm:ss")
              : undefined,
            validEndDate: p.validEndDate
              ? moment(p.validEndDate).format("YYYY-MM-DD HH:mm:ss")
              : undefined,
          })),
        };
        Ajax.post(
          "/api/services/app/Coupon/CreateCourtCouponByCourt",
          payload
        ).then((res) => {
          if (res && res.data) {
            this.$emit("input", false);
            (this.$refs.couPonRef as any).resetFields();
            this.$Message.success("发放成功");
          }
        });
      }
    });
  }

  submitAll() {
    (this.$refs.couPonRef as any).validate((valid: boolean) => {
      if (valid) {
        //用moment处理为了避免时区造成的时间差问题
        const payload = {
          courtId: this.coupon.courtId,
          quantity: this.coupon.quantity,
          validStartDate: this.coupon.validStartDate
            ? moment(this.coupon.validStartDate).format("YYYY-MM-DD HH:mm:ss")
            : undefined,
          onlyHasAmount: false,
          validPeriods: (this.coupon.validPeriods || []).map((p) => ({
            validStartDate: p.validStartDate
              ? moment(p.validStartDate).format("YYYY-MM-DD HH:mm:ss")
              : undefined,
            validEndDate: p.validEndDate
              ? moment(p.validEndDate).format("YYYY-MM-DD HH:mm:ss")
              : undefined,
          })),
        };
        this.$store
          .dispatch({
            type: "coupon/CreateCourtCouponForAllUsers",
            data: payload,
          })
          .then((res) => {
            if (res) {
              this.$Message.success("发放优惠券成功");
            }
          });
        this.$emit("input", false);
        (this.$refs.couPonRef as any).resetFields();
      }
    });
  }

  submitAmount() {
    (this.$refs.couPonRef as any).validate((valid: boolean) => {
      if (valid) {
        const payload = {
          courtId: this.coupon.courtId,
          quantity: this.coupon.quantity,
          validStartDate: this.coupon.validStartDate
            ? moment(this.coupon.validStartDate).format("YYYY-MM-DD HH:mm:ss")
            : undefined,
          onlyHasAmount: true,
          validPeriods: (this.coupon.validPeriods || []).map((p) => ({
            validStartDate: p.validStartDate
              ? moment(p.validStartDate).format("YYYY-MM-DD HH:mm:ss")
              : undefined,
            validEndDate: p.validEndDate
              ? moment(p.validEndDate).format("YYYY-MM-DD HH:mm:ss")
              : undefined,
          })),
        };
        this.$store
          .dispatch({
            type: "coupon/CreateCourtCouponForAllUsers",
            data: payload,
          })
          .then((res) => {
            if (res) {
              this.$Message.success("发放优惠券成功");
            }
          });
        this.$emit("input", false);
        (this.$refs.couPonRef as any).resetFields();
      }
    });
  }

  async getCourtList() {
    const response = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = response.data.result;
  }

  cancel() {
    (this.$refs.couPonRef as any).resetFields();
    this.$emit("input", false);
  }

  visibleChange(show: boolean) {
    if (!show) {
      this.$emit("input", show);
      this.$nextTick(() => {
        (this.$refs.couPonRef as any) &&
          (this.$refs.couPonRef as any).resetFields();
        this.coupon = new Coupon();
        this.isShow = true;
      });
    } else {
      this.getCourtList();
      if (this.userIds && this.userIds.length > 0) {
        this.isShow = true;
        this.coupon.userIds = this.userIds;
      } else {
        this.isShow = false;
      }
    }
  }
  validateQuantity(rule, value, callback) {
    if (!value) {
      callback(new Error("请输入发券数量"));
    } else {
      // 转换为数字
      const num = Number(value);
      if (isNaN(num)) {
        callback(new Error("请输入有效的数字"));
      } else if (num < 1) {
        callback(new Error("发券数量必须大于0"));
      } else if (!Number.isInteger(num)) {
        callback(new Error("发券数量必须为整数"));
      } else {
        callback();
      }
    }
  }
  validateCourtId(rule, value, callback) {
    if (!value) {
      callback(new Error("请选择球场"));
    } else {
      callback();
    }
  }

  validatePeriods(rule, value, callback) {
    const periods = this.coupon.validPeriods || [];
    for (let i = 0; i < periods.length; i++) {
      const p = periods[i];

      // 必填校验
      if (!p.validStartDate || !p.validEndDate) {
        callback(new Error(`第 ${i + 1} 个时间段：请填写完整开始和结束时间`));
        return;
      }

      if (p.validStartDate >= p.validEndDate) {
        callback(new Error(`第 ${i + 1} 个时间段：开始时间不能晚于结束时间`));
        return;
      }
    }
    callback();
  }
  couPonRule = {
    courtId: [
      { required: true, validator: this.validateCourtId, trigger: "change" },
    ],
    quantity: [
      { required: true, validator: this.validateQuantity, trigger: "blur" },
    ],
    validStartDate: [
      {
        required: true,
        type: "date",
        message: "请选择优惠券开始时间",
        trigger: "change",
      },
    ],
    validPeriods: [{ validator: this.validatePeriods, trigger: "change" }],
  };
}
